import React, { useEffect, useRef, useState } from "react";

import { useTranslation } from "react-i18next";

import {
  DropDownContainer,
  DropDownHeader,
  DropDownList,
  DropDownListContainer,
  Label,
  ListItem,
} from "./styles";
import ArrowDown from "../../assets/svg/arrow-down.svg";
import ArrowUp from "../../assets/svg/arrow-up.svg";
import Selected from "../../assets/svg/Selected.svg";
import { CircleBadge } from "../Badges/Circle";

export interface IDropDown {
  name: string;
  id: number | string;
  selected?: boolean;
  enabled?: boolean;
}
export interface iDropdown {
  labelName: React.ReactNode;
  options: IDropDown[];
  defaultValue?: string;
  setSelected: any;
  editDropdown?: any;
  required?: boolean;
  isNotFileDefault?: boolean;
  selected?: any;
  selectedIndex?: number;
  error?: boolean;
  width?: string;
  height?: string;
  marginLeft?: string;
  marginRight?: string;
  withoutMarginBottom?: boolean;
  wantAnObject?: boolean;
  disabled?: boolean;
  onCloseDropDown?: any;
  isAttedantProcedure?: boolean;
  showDefaultValue?: boolean;
  id?: string;
}

const SELECT_PLACEHOLDER = "__SELECT__";

export const DropdownGlobal: React.FC<iDropdown> = (props) => {
  const { t } = useTranslation();
  const selectLabel = t("common.select");
  const {
    labelName,
    options,
    setSelected,
    editDropdown,
    defaultValue,
    isNotFileDefault = false,
    required = false,
    error = false,
    width = "380px",
    height,
    wantAnObject,
    disabled,
    marginRight,
    withoutMarginBottom = false,
    isAttedantProcedure,
    selected,
    selectedIndex,
    onCloseDropDown,
    showDefaultValue,
    id,
  } = props;

  const [isOpen, setIsOpen] = useState(false);
  const [errorDrop, setErrorDrop] = useState(false);
  const [errorDropRequired, setErrorDropRequired] = useState<boolean>(false);
  const [selectedOption, setSelectedOption] = useState(
    editDropdown && !isNotFileDefault
      ? editDropdown
      : defaultValue || SELECT_PLACEHOLDER,
  );

  useEffect(() => {
    if (!selected && !editDropdown) setSelectedOption(SELECT_PLACEHOLDER);
  }, [selected, editDropdown]);

  const statusRef = useRef<any>(null);

  useEffect(() => {
    if (selectedOption && selectedOption !== SELECT_PLACEHOLDER) {
      setErrorDropRequired(error);
      setErrorDrop(false);
    } else {
      setErrorDropRequired(error);
    }
  }, [error, errorDrop]);

  useEffect(() => {
    if (showDefaultValue && selectedOption !== SELECT_PLACEHOLDER) {
      setSelectedOption(SELECT_PLACEHOLDER);
    }
  }, [defaultValue]);

  const toggling = () => {
    if (isOpen && selectedOption === SELECT_PLACEHOLDER) {
      setErrorDrop(true);
    } else {
      setErrorDrop(false);
    }
    setIsOpen((p) => !p);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>) => {
    if (disabled || !options?.length) return;
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      toggling();
    } else if (e.key === "Escape") {
      setIsOpen(false);
    } else if (e.key === "ArrowDown") {
      e.preventDefault();
      setIsOpen(true);
    }
  };

  const onOptionClicked = (value: any, option?: any, index?: number) => () => {
    setSelectedOption(value);
    setSelected(value);
    setIsOpen(false);

    if (isAttedantProcedure) {
      setSelected(option.procedureCustomerAttendantId);
      setErrorDrop(false);
      setErrorDropRequired(false);
      return;
    }

    if (wantAnObject && option) {
      setSelected(option, index);
      setErrorDrop(false);
      setErrorDropRequired(false);
      return;
    }

    if (option) {
      setSelected(option?.id, index);
      setErrorDrop(false);
      setErrorDropRequired(false);
    }
  };

  useEffect(() => {
    setIsOpen(false);
  }, [onCloseDropDown]);

  useEffect(() => {
    const handleDocumentClick = (e: any) => {
      if (statusRef.current && !statusRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, [setIsOpen, statusRef]);

  const headerId = id || "drop_header";
  const listboxId = `${headerId}-listbox`;

  return (
    <DropDownContainer
      width={width}
      withoutMarginBottom={withoutMarginBottom}
      marginRight={marginRight}
      id="dropDownContainer"
      ref={statusRef}
    >
      <Label>{labelName}</Label>
      {required && <CircleBadge radius="50px" widthHeigt="8px" />}
      <DropDownHeader
        id={headerId}
        data-cy={headerId}
        type="button"
        aria-haspopup="listbox"
        aria-expanded={isOpen}
        aria-controls={listboxId}
        disable={Boolean(disabled || !options || options.length <= 0)}
        error={errorDropRequired}
        focus={isOpen}
        height={height}
        showDefaultValue={showDefaultValue}
        onClick={() => {
          if (!disabled && options && options.length > 0) toggling();
        }}
        onKeyDown={handleKeyDown}
        selected={selectedOption !== SELECT_PLACEHOLDER}
      >
        {/* TODO: testar aqui Adriano */}
        <span>
          {selectedOption === SELECT_PLACEHOLDER && showDefaultValue
            ? defaultValue
            : selectedOption === SELECT_PLACEHOLDER
              ? selectLabel
              : typeof selectedOption === "object" && selectedOption !== null
                ? selectedOption.name || selectedOption.label || "---"
                : String(selectedOption || "---")}
        </span>

        {!disabled && (
          <img
            className="icon"
            src={isOpen ? ArrowUp : ArrowDown}
            alt=""
            aria-hidden="true"
          />
        )}
      </DropDownHeader>
      {isOpen && (
        <DropDownListContainer>
          <DropDownList
            width={width}
            role="listbox"
            id={listboxId}
            aria-labelledby={headerId}
          >
            {options?.map((item: any, index: any) => {
              const isSelected =
                selectedIndex !== undefined
                  ? selectedIndex === index
                  : typeof selectedOption === "object"
                    ? selectedOption.id === item.id
                    : selectedOption === item.name ||
                      selectedOption === item.label;

              return (
                <ListItem
                  role="option"
                  aria-selected={isSelected}
                  data-cy="itemlista"
                  onClick={() => {
                    if (!item.disabled) {
                      onOptionClicked(
                        item.name || item.label || item,
                        item,
                        index,
                      )();
                    }
                  }}
                  key={index}
                  selected={isSelected}
                  tabIndex={-1}
                >
                  <span style={{ opacity: item?.disabled ? 0.4 : 1 }}>
                    {item?.name || item.label || item}
                  </span>
                  {isSelected ? (
                    <img src={Selected} alt="" aria-hidden="true" />
                  ) : null}
                </ListItem>
              );
            })}
          </DropDownList>
        </DropDownListContainer>
      )}
    </DropDownContainer>
  );
};
